export default {
  equipment: 'Equipamento',
  service: 'Serviço',
  createdAt: 'Criado em',
  lastModifiedAt: 'Modificado em',
  actions: 'Ações',
  place: 'Local',
  fromCreatedAt: 'Criado De:',
  toCreatedAt: 'Criado Até:',
  fromModifiedAt: 'Modificado De:',
  toModifiedAt: 'Modificado Até:',
  pageTitle: 'Rascunhos de Serviços',
  finishService: 'Finalizar Serviço',
  deleteDraftTitle: 'Excluir Rascunho de Serviço',
  deleteDraftMessage: 'Tem certeza que deseja excluir o rascunho de serviço?',
};